import { useEffect, useMemo } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ProjectsHero from './components/ProjectsHero';
import ProjectsGallery from './components/ProjectsGallery';
import CTASection from '../home/components/CTASection';
import SEO from '../../components/feature/SEO';
import JsonLd from '../../components/feature/JsonLd';

export default function ProjektePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://igm-baudienste.com';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jsonLdData = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    '@id': `${siteUrl}/projekte`,
    'url': `${siteUrl}/projekte`,
    'name': 'Projekte & Referenzen | IGM Facility Service Ratingen',
    'description': 'Sehen Sie abgeschlossene Projekte und Referenzen von IGM Facility Service – Gebäudereinigung, Gartenbau und Malerarbeiten in Ratingen und Umgebung.',
    'isPartOf': { '@id': `${siteUrl}/#website` },
    'about': { '@id': `${siteUrl}/#business` },
  }), [siteUrl]);

  const breadcrumbData = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'Home',
        'item': siteUrl,
      },
      {
        '@type': 'ListItem',
        'position': 2,
        'name': 'Projekte & Referenzen',
        'item': `${siteUrl}/projekte`,
      },
    ],
  }), [siteUrl]);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <SEO
        title="Projekte & Referenzen | IGM Facility Service Ratingen"
        description="Sehen Sie abgeschlossene Projekte und Referenzen von IGM Facility Service – Gebäudereinigung, Gartenbau und Malerarbeiten in Ratingen und Umgebung."
        keywords="Referenzen Facility Service Ratingen, Bauprojekte NRW, Gebäudereinigung Referenzen"
        canonical={`${siteUrl}/projekte`}
      />
      <JsonLd data={jsonLdData} id="json-ld-projekte" />
      <JsonLd data={breadcrumbData} id="json-ld-projekte-breadcrumb" />
      <Navbar />
      <ProjectsHero />
      <ProjectsGallery />
      <CTASection />
      <Footer />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-24 right-4 sm:bottom-8 sm:right-8 w-12 h-12 sm:w-14 sm:h-14 bg-[#0D2B4E] text-white rounded-full hover:bg-[#0a2240] transition-all flex items-center justify-center z-40 cursor-pointer"
        aria-label="Nach oben"
      >
        <i className="ri-arrow-up-line text-xl sm:text-2xl" />
      </button>
    </div>
  );
}
